import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TranslatorService {
  constructor(public translate: TranslateService) {
    if (!translate.getDefaultLang()) {
      translate.setDefaultLang('en');
    }
  }

  translateText(key: string): string {
    // Use TranslateService if available, otherwise return key
    let result = key;
    this.translate.get(key).subscribe((value: string) => {
      result = value !== key ? value : key;
    });
    return result;
  }

  get(key: string | string[]): Observable<string | any> {
    return this.translate.get(key);
  }

  instant(key: string | string[]): string {
    return this.translate.instant(key);
  }

  getCurrentLanguage(): string {
    return this.translate.currentLang || this.translate.defaultLang || 'en';
  }
}

